export const POPUP_STATE = "POPUP_STATE";
export const POPUP_OPEN_STATE = "POPUP_OPEN_STATE";
export const POPUP_OPEN_SUB_STATE = "POPUP_OPEN_SUB_STATE";
export const POPUP_OPEN_FIRST_STATE = "POPUP_OPEN_FIRST_STATE";
export const POPUP_RESET_STATE = "POPUP_RESET_STATE";
export const ALL_POPUP_STATE = "ALL_POPUP_STATE";

export const allPopupOpenState = (state) => ({
  type: ALL_POPUP_STATE,
  payload: state,
});

export const popupOpenState = (state) => ({
  type: POPUP_OPEN_STATE,
  payload: state,
});

export const popupDateState = (data) => ({
  type: POPUP_STATE,
  payload: data,
});

export const popupSubOpenState = (state) => ({
  type: POPUP_OPEN_SUB_STATE,
  payload: state,
});

export const popupFirstGet = (state) => ({
  type: POPUP_OPEN_FIRST_STATE,
  payload: state,
});

export const popupResetState = () => ({
  type: POPUP_RESET_STATE,
});
